<template>
    <div>
        <div
            v-for="(field, keyName, index) in this.formFields"
            :key="field.name"
            :class="field.wrapperClass"
        >
            <!-- hidden -->
            <InputElm
                v-if="field.type === 'hidden'"
                :inputConfig="field.config"
                @input="handleInput($event, field.name)"
            >
            </InputElm>

            <LabelInputSheerID
                v-else-if="field.config.name === 'university'"
                :inputConfig="field.config"
                :errorMessage="field.errorMessage"
                @input="handleSheerIDInput($event)"
                @blur="handleBlur(null, field.name)"
                @keyup="handleKeyUp"
            >
            </LabelInputSheerID>

            <!-- birth date -->
            <LabelInputBirthDate
                v-else-if="
                    field.type === 'birthdate' ||
                    field.type === 'date' ||
                    field.config.fieldType === 'date'
                "
                :inputConfig="field.config"
                :errorMessage="field.errorMessage"
                @keyup="handleKeyUp"
                @input="handleInput($event, field.name)"
                @blur="handleBlur(null, field.name)"
            >
            </LabelInputBirthDate>

            <!-- text, email, password -->
            <LabelInput
                v-else-if="
                    field.type === 'text' || field.type === 'email' || field.type === 'password'
                "
                :inputConfig="field.config"
                :errorMessage="field.errorMessage"
                :elementIndex="index"
                @keyup="handleKeyUp"
                @input="handleInput($event, field.name)"
                @blur="handleBlur($event, field.name)"
                @showHidePasswordStatus="relayShowHidePasswordStatus"
            >
            </LabelInput>

            <!-- checkbox -->
            <CheckboxElm
                v-else-if="field.type === 'checkbox'"
                :checkboxConfig="field.config"
                :errorMessage="field.errorMessage"
                @change="handleInput($event, field.name)"
                @trackCheckBox="handleTrackCheckBox($event, field.name)"
            >
            </CheckboxElm>

            <!-- custom select -->
            <CustomSelect
                v-else-if="field.type === 'select'"
                :selectConfig="field.config"
                :errorMessage="field.errorMessage"
                @input="handleInput($event, field.name)"
                @blur="handleBlur($event, field.name)"
            >
            </CustomSelect>

            <RecurlyHostedField
                v-else-if="field.type === 'recurly-hosted'"
                :inputConfig="field.config"
                :errorMessage="field.errorMessage"
                @input="handleInput($event, field.name)"
                @blur="handleBlur($event, field.name)"
            >
            </RecurlyHostedField>

            <div role="alert"  aria-live="polite" class="text-input-error" v-if="field.errorMessage">
                {{ field.errorMessage }}
            </div>
        </div>
    </div>
</template>

<script>
    import CheckboxElm from 'atoms/CheckboxElm';
    import CustomSelect from 'atoms/CustomSelect';
    import InputElm from 'atoms/InputElm';
    import LabelInput from 'atoms/LabelInput';
    import LabelInputBirthDate from 'atoms/LabelInputBirthDate';
    import LabelInputSheerID from 'atoms/LabelInputSheerID';
    import RecurlyHostedField from 'atoms/RecurlyHostedField';
    import { mapState } from 'vuex';

    export default {
        name: 'FormFields',
        components: {
            RecurlyHostedField,
            CustomSelect,
            InputElm,
            LabelInput,
            LabelInputBirthDate,
            CheckboxElm,
            LabelInputSheerID
        },

        props: {
            formFieldList: {
                type: Object,
                required: true
            },

            fieldErrors: {
                type: Object,
                required: true
            },

            itemWrapperClass: {
                type: Function,
                required: false,
                default: (fieldConfig) => {
                    let classList = ['grid-item'];

                    if (fieldConfig && typeof fieldConfig === 'object') {
                        if (typeof fieldConfig.name === 'string') {
                            classList.push(`grid-item--${fieldConfig.name}`);
                        }

                        if (fieldConfig.type === 'hidden') {
                            classList.push(`grid-item--hidden`);
                        }
                    }

                    return classList;
                }
            }
        },

        computed: {
            formFields() {
                let formFields = {};
                for (let key in this.formFieldList) {
                    if (!this.formFieldList.hasOwnProperty(key)) continue;

                    let config = this.formFieldList[key];
                    let { name, type } = config;
                    formFields[key] = {
                        name,
                        type,
                        config,
                        wrapperClass: this.itemWrapperClass(config),
                        errorMessage: this.fieldErrors[name]
                    };
                }

                return formFields;
            },
            ...mapState('pageAttributes', {
                pageAttr: (state) => state.attributes
            })
        },

        methods: {
            relayShowHidePasswordStatus(payload) {
                this.$emit('showHidePasswordStatus', payload)
            },
            handleInput(e, name) {
                this.updateFieldValue(name, e.value);
                this.validateField('input', name);
            },

            handleTrackCheckBox(e, name) {
                this.$emit('trackCheckBox', e.value, name);
            },

            handleSheerIDInput(e) {
                this.handleInput(e, e.name);
            },

            handleBlur(e, name) {
                // check if event has delayed payload
                if (e && typeof e === 'object' && 'value' in e) {
                    this.updateFieldValue(name, e.value);
                }

                this.validateField('blur', name);
            },

            handleKeyUp(e) {
                if (e.event.keyCode === 13) {
                    this.$emit('validateForm', { on: 'submit' });
                }
            },

            updateFieldValue(name, val) {
                let value = typeof val === 'string' ? val.trim() : val;

                this.$emit('updateFormData', { [name]: value });
            },

            validateField(on, name) {
                this.$emit('validateField', { name, on });
            }
        }
    };
</script>
